var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuIcReview = function SvgMenuIcReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6EBFF",
    stroke: "#131317",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M20.327 6.848a3 3 0 0 0-3-3H6.67a3 3 0 0 0-3 3v7.059a2.81 2.81 0 0 0 2.81 2.81c.518 0 .938.42.938.938v1.858a.3.3 0 0 0 .49.232l3.397-2.799a1 1 0 0 1 .636-.228h5.385a3 3 0 0 0 3-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131317",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.093 8.016h9.814M7.093 12h5.853"
  })));
};
export default SvgMenuIcReview;